import {mixins} from "../app/mixin";

mixins.push({
    el: '.co2nnectorProPage',
    data: () => ({
        selectedCard: 1,
        selectedPricePlan: 1,
    }),
    methods: {
        selectCard(cardId) {
            if (this.selectedCard !== cardId) {
                this.selectedCard = cardId
            }
        },
        selectPricePlan(pricePlanId) {
            if (this.selectedPricePlan !== pricePlanId) {
                this.selectedPricePlan = pricePlanId
            }
        },
    },
});
